import React, { useState, useEffect } from "react";
import "./adminJobPost.css";
import {
  collection,
  addDoc,
  serverTimestamp,
  getDocs,
  deleteDoc,
  doc,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase";

const AdminPostJob = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);

  const [job, setJob] = useState({
    title: "",
    description: "",
    location: "",
    type: "",
    salary: "",
  });

  // Handle input change
  const handleChange = (e) => {
    setJob({ ...job, [e.target.name]: e.target.value });
  };

  // Fetch Jobs
  const fetchJobs = async () => {
    const q = query(collection(db, "jobs"), orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);
    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setJobs(data);
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  // Submit Job
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!job.title || !job.description || !job.location || !job.type) {
      alert("Please fill all required fields ⚠️");
      return;
    }

    setLoading(true);

    try {
      await addDoc(collection(db, "jobs"), {
        ...job,
        createdAt: serverTimestamp(),
      });

      setJob({
        title: "",
        description: "",
        location: "",
        type: "",
        salary: "",
      });

      fetchJobs();
      alert("Job Posted Successfully 🚀");
    } catch (error) {
      console.error(error);
      alert("Error posting job ❌");
    }

    setLoading(false);
  };

  // Delete Job
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure to delete this job?");
    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, "jobs", id));
      fetchJobs();
    } catch (error) {
      alert("Error deleting job ❌");
    }
  };

  return (
    <div className="job-management">

      {/* Header */}
      <div className="job-header">
        <h2>💼 Job Management</h2>
        <span className="job-count">Total Jobs: {jobs.length}</span>
      </div>

      <div className="job-layout">

        {/* LEFT - FORM */}
        <div className="job-form-card">
          <h3>Create New Job</h3>

          <form onSubmit={handleSubmit}>

            <input
              type="text"
              name="title"
              placeholder="Job Title"
              value={job.title}
              onChange={handleChange}
            />

            <textarea
              name="description"
              placeholder="Job Description"
              value={job.description}
              onChange={handleChange}
            />

            <div className="row">
              <input
                type="text"
                name="location"
                placeholder="Location"
                value={job.location}
                onChange={handleChange}
              />

              <select
                name="type"
                value={job.type}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                <option value="Full Time">Full Time</option>
                <option value="Part Time">Part Time</option>
                <option value="Internship">Internship</option>
                <option value="Remote">Remote</option>
              </select>
            </div>

            <input
              type="text"
              name="salary"
              placeholder="Salary"
              value={job.salary}
              onChange={handleChange}
            />

            <button type="submit" className="primary-btn">
              {loading ? "Posting..." : "Post Job"}
            </button>

          </form>
        </div>

        {/* RIGHT - JOB LIST */}
        <div className="job-list-card">
          <h3>Posted Jobs</h3>

          {jobs.length === 0 ? (
            <p className="empty">No jobs posted yet.</p>
          ) : (
            jobs.map((item) => (
              <div className="job-card" key={item.id}>
                <div className="job-info">
                  <h4>{item.title}</h4>
                  <p className="meta">
                    📍 {item.location} | 💼 {item.type}
                  </p>
                  <p className="salary">💰 {item.salary}</p>
                  <p className="desc">{item.description}</p>
                </div>

                <button
                  className="delete-btn"
                  onClick={() => handleDelete(item.id)}
                >
                  Delete
                </button>
              </div>
            ))
          )}
        </div>

      </div>
    </div>
  );
};

export default AdminPostJob;